import React, { useRef } from 'react';
/**
 * Components
 */
 import HomeBanner from "@Components/Home/HomeBanner/HomeBanner";
 import StaticPageBanner from "@Components/StaticPage/StaticPageBanner/StaticPageBanner";
 import StaticPageContent from "@Components/StaticPageContent/StaticPageContent"
 import HomeIntro from "@Components/Home/HomeIntro/HomeIntro";
 import HomeGetStart from "@Components/Home/HomeGetStart/HomeGetStart";
 import Valuation from "@Components/Valuation/valuation";
 import HowCanWeHelp from "@Components/Home/HowCanWeHelp/HowCanWeHelp";
 import HomeTeam from "@Components/Home/HomeTeam/HomeTeam";
 import HomeBookConsultation from "@Components/Home/HomeBookConsultation/HomeBookConsultation";
 import FeaturedProperties from "@Components/PropertyDetails/FeaturedProperties/FeaturedProperties";
 import HelpModule from "@Components/Home/HomeBookConsultation/HelpModule";
 import BreadcrumbPage from "@Components/Home/BreadcrumbPage/BreadcrumbPage";
 import BookAConsultation from "@Components/BookAConsultation/BookAConsultation";
 import ServiceBlocks from "@Components/StaticPage/RelatedProperties/RelatedProperties";
 import News from "@Components/StaticPage/News/News";
 import InvestmentNews from "@Components/StaticPage/InvestmentNews/InvestmentNews";
 import Teams from "@Components/StaticPage/Teams/Teams";
 import Careers from "@Components/StaticPage/Careers/Careers";
 import Offices from "@Components/StaticPage/Offices/Offices";
 import Letting from "@Components/StaticPage/Letting/Letting";
 import Areaguides from "@Components/StaticPage/Areaguides/Areaguides";
 import AreaguidesList from "@Components/StaticPage/Areaguides/AreaguidesList";
 import DetailIntro from "@Components/PropertyDetails/PropertyDescription/detail-intro";
 import StepsModule from "@Components/StaticPage/BuyingProperty/StepsContent";
 import FeaturedProperty from "@Components/PropertyDetails/FeaturedProperties/FeaturedProperties";
 import MortgageCalc from "@Components/calculators/mortgagecalc/index";
import CustomerTestimonials from "@Components/StaticPage/CustomerTestimonials/CustomerTestimonials";
import Ethics from "@Components/StaticPage/Ethics/Ethics";
import LandingMap from "@Components/landing-map";
import DetailMap from "@Components/detail-map";
import ReviewsList from "@Components/reviews-listing";
import ReviewsListModule from "@Components/reviews-listing-module";
import CustomIframe from '@Components/CustomIframe/CustomIframe';
import { isMacOs, isSafari } from 'react-device-detect';

const Modules = (props) => {
    const AreaBlocks = props.Modules?props.Modules[1]:'';
    const myRef = useRef(null)
    const executeScroll = () => {
        myRef.current.scrollIntoView({ behavior: 'smooth'})
    }
    console.log('propsprops', props)
    return (

        <div className={`${(isSafari || isMacOs) ? "mac-saf" : ""}`}>  {props.Page.Banner_Image ?
            <StaticPageBanner executeScroll={executeScroll} data={props.Page}/>
            : props.Page.isHomePage ?
            <HomeBanner data={props.Page} executeScroll={executeScroll}/>
            : null
            }
            {props.Modules && props.Modules?.length > 0 ? props.Modules.map((Module, i) => {
                return (
                    <div key={i}>
                        {Module.Person_Image?.url &&
                        <HomeIntro
                        Video_Url={Module.Video_Url}
                        Title={Module.Title}
                        Title1={Module.Title1}
                        Title2={Module.Title2}
                        Person_Image={Module.Person_Image}
                        Add_Cta={Module.Add_Cta}
                        Cta={Module.Cta}
                        />
                        }
                        {Module.__typename === "GLSTRAPI_ComponentModuleServicesCta" &&
                        <>
                        {Module.Add_Cta_Tail && Module.Add_Cta_Tail[0].Add_Sub_Cta.length <= 0 ?
                        <HowCanWeHelp investments={props.Page.Alias === 'investments' ? true : false} isMainPage={props.Page.Pagename === "Home" ? true : false} Title={Module.Title} SubTitle={Module.Sub_Title} Content={Module.Content}
                        CTAS = {Module.Add_Cta_Tail} />
                        :
                        <ServiceBlocks Title={Module.Title} SubTitle={Module.Sub_Title} Content={Module.Content}
                        CTAS = {Module.Add_Cta_Tail} />
                        }
                        </>                        
                        }
                        {Module.Select_Collection === "Book_a_Consultation" &&
                            <BookAConsultation Content={Module.Content}
                            Sub_Title={Module.Sub_Title}
                            Title={Module.Title}
                            Image={Module.Right_Image}
                            imagetransforms={props.Page.imagetransforms}
                            ggfx_results={props.Page.ggfx_results}
                            id={props.Page.id}
                            Type="consult"
                            />
                        }
                        {Module.Select_Collection === "Book_a_Video" &&
                            <BookAConsultation 
                            Content={Module.Content}
                            Sub_Title={Module.Sub_Title}
                            Title={Module.Title}
                            Image={Module.Right_Image}
                            imagetransforms={props.Page.imagetransforms}
                            ggfx_results={props.Page.ggfx_results}
                            id={props.Page.id}
                            Type="video"
                            />
                        }
                        {Module.__typename === "GLSTRAPI_ComponentModuleContentBlock" &&
                            <DetailIntro Video_Url={Module.Video_Url} Content={Module.Content} Image={Module.Image} />
                        }
                        {Module.__typename === "GLSTRAPI_ComponentModuleStepsBlock" &&
                            <StepsModule Title={Module.Title} Content={Module.Content} Steps={Module.Add_Step} />
                        }
                        {Module.__typename === "GLSTRAPI_ComponentModuleIframeBlock" &&
                            <CustomIframe iurl={Module.URL} externalCssLink={Module.external_css_url} externaljsLink={Module.external_js_url} />
                        }
                        {Module.__typename === "GLSTRAPI_ComponentModuleStaticPageContent" &&
                            <StaticPageContent Content={Module.Content} Title={props.Page.Pagename} />
                        }
                        {Module.Select_Collection === "GetStart" &&
                            <HomeGetStart  
                            nobanner={props.Page.Alias === 'careers' ? true : false}
                            Content={Module.Content}
                                Sub_Title={Module.Sub_Title}
                                Title={Module.Title}
                              />
                        }
                        {Module.Select_Collection === "Valuation" && props.Page.Pagename !== "Home" &&
                            <Valuation/>
                        }
                        {Module.Select_Collection === "Careers" && props.Page.Pagename !== "Home" &&
                        <>
                        <div ref={myRef}></div>
                        <Careers 
                            Content={Module.Content}
                                Sub_Title={Module.Sub_Title}
                                Title={Module.Title}
                                 />
                                 </>
                        }
                        {Module.Add_Section?.length > 0 &&
                        <div className="ethik-blk">
                        <Ethics sections={Module.Add_Section} />
                        </div>
                        }
                        {Module.Select_Collection === "Featured_Properties" &&
                            <FeaturedProperty area={Module.Title ? Module.Title : 'Oxford'}  />
                        }
                        {Module.Select_Collection === "Mortgage_Calculator" &&
                            <MortgageCalc class="page-calculator"/>
                        }
                        {Module.Select_Collection === "Blogs" &&
                            <News 
                                Select_Collection={Module.Select_Collection}
                                Content={Module.Content}
                                Sub_Title={Module.Sub_Title}
                                Title={Module.Title}
                            />
                        }
                        
                        {Module.Select_Collection === "Investment_Case_Studies" &&
                            <InvestmentNews 
                                Select_Collection={Module.Select_Collection}
                                Content={Module.Content}
                                Sub_Title={Module.Sub_Title}
                                Title={Module.Title}
                            />
                        }
                        {Module.Select_Collection === "Customers_Google_Reviews" &&
                            <ReviewsListModule 
                                Select_Collection={Module.Select_Collection}
                                Content={Module.Content}
                                Sub_Title={Module.Sub_Title}
                                Title={Module.Title}
                            />
                        }
                        {Module.Select_Collection === "Teams" &&
                            <Teams 
                                Select_Collection={Module.Select_Collection}
                                Content={Module.Content}
                                Sub_Title={Module.Sub_Title}
                                Title={Module.Title}
                            />
                        }
                        {Module.Select_Collection === "Officess" && props.Page.Pagename !== "Home" &&
                            <Offices 
                                Select_Collection={Module.Select_Collection}
                                Content={Module.Content}
                                Sub_Title={Module.Sub_Title}
                                Title={Module.Title}
                            />
                        }
                        {Module.__typename === "GLSTRAPI_ComponentModuleContentGridBlock" &&
                            <Letting {...Module} />
                        }
                        
                        {Module.Select_Collection === "Areaguides" && props.Page.Pagename !== "Home" &&
                            <Areaguides 
                                Select_Collection={Module.Select_Collection}
                                Content={Module.Content}
                                Sub_Title={Module.Sub_Title}
                                Title={Module.Title}
                                modules = {AreaBlocks}
                            />
                        }
                        {Module.Select_Module ==="Areaguide_Landing_Map" &&
                            <LandingMap />
                        }
                        {Module.Select_Module ==="Areaguide_Detail_Map" &&
                            <DetailMap Name={props.Page.Name} Latitude={props.Page.Latitude} Longitude={props.Page.Longitude} />
                        }
                        {Module.Select_Module ==="Find_Property_Form" &&
                            <HelpModule Title={Module.Title}
                            Content={Module.Content} />
                        }   
                        {Module.Select_Collection === "Testimonials" &&
                            <CustomerTestimonials />
                        }
                        {Module.Select_Module === "Reviews_Listing" &&
                            <ReviewsList />            
                        }
                        {Module.Book_Title &&
                            <HomeBookConsultation
                            Title={Module.Book_Title}
                            Content={Module.Content}
                            Cta_Label_1={Module.Cta_Label_1}
                            Cta_Label_2={Module.Cta_Label_2}
                            Cta_Url_2={Module.Cta_Url_2}
                            Cta_Url_1={Module.Cta_Url_1}
                            />
                        }
                        {/* {JSON.stringify(Module.Offices)} */}
                        {Module.Offices?.length > 0 &&
                            <HomeTeam Offices={Module.Offices} />
                        }

                    </div>
                )

            }) : ''
            }
            {props.areaguidepage && props.Page.Pagename !== "Home" ? <>
                <FeaturedProperties area={props.Page?.Name?.replace(' Area Guide', "")}/>
            <BreadcrumbPage Page={props.Page.Name} class="static" alias={'our-areas'} type="details-page"/>
            </>
            : props.Page.Pagename !== "Home" ?
            <BreadcrumbPage Page={props.Page.Pagename} alias={props.Page.Alias}/>
            
             : null}
        </div>

    )
}
export default Modules
